import { render, staticRenderFns } from "./c_home_discover.vue?vue&type=template&id=1f0c8727&scoped=true"
import script from "./c_home_discover.vue?vue&type=script&lang=js"
export * from "./c_home_discover.vue?vue&type=script&lang=js"
import style0 from "./c_home_discover.vue?vue&type=style&index=0&id=1f0c8727&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c8727",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0c8727')) {
      api.createRecord('1f0c8727', component.options)
    } else {
      api.reload('1f0c8727', component.options)
    }
    module.hot.accept("./c_home_discover.vue?vue&type=template&id=1f0c8727&scoped=true", function () {
      api.rerender('1f0c8727', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_discover.vue"
export default component.exports